<template>
  <section class="positioner">
    <section
      v-if="inputsState.isVisible"
    >
      <movement-sides
        v-if="movementButtonsState.isActive"
        :disabled="inputsState.disabled"
        @position="changeMovement"
        @end-contact="endContact"
      />
      <section
        v-if="!gameSettingsState.isLeft"
        class="flex justify-between"
      >
        <joy-stick
          v-if="actionButtonState.showJoystick"
          :disabled="inputsState.disabled"
        />
        <section
          v-else
          class="placeholder"
        />
        <section v-show="!actionButtonState.showJoystick" />
        <section
          class="relative bottom-right"
          :style="{transform: `scale(${scaleCoef})`}"
        >
          <action-button
            v-if="!movementButtonsState.isActive"
          />
          <!-- <movement-buttons-component v-else /> -->
        </section>
      </section>
      <section
        v-else
        class="flex justify-between"
      >
        <section
          class="relative bottom-left"
          :style="{transform: `scale(${scaleCoef})`}"
        >
          <action-button
            v-if="!movementButtonsState.isActive"
          />
          <!-- <movement-buttons-component v-else /> -->
        </section>
        <joy-stick
          v-if="actionButtonState.showJoystick"
          :disabled="inputsState.disabled"
        />
        <section
          v-else
          class="placeholder"
        />
      </section>
    </section>
  </section>
</template>

<script lang="ts">
import JoyStick from './JoyStick.vue'
import ActionButton from './ActionButton.vue'
import { defineComponent } from 'vue'
import {
  gameSettingsState,
  MovementSides,
  WindowAspect
} from '@powerplay/core-minigames-ui'
import { inputsManager } from '@powerplay/core-minigames'
import {
  actionButtonState,
  inputsState,
  movementButtonsState,
  movementState
} from '@/stores'

export default defineComponent({
  name: 'MobileInputs',
  components: {
    JoyStick,
    ActionButton,
    MovementSides
  },
  mixins: [WindowAspect],
  data() {

    return {
      actionButtonState: actionButtonState(),
      inputsState: inputsState(),
      movementButtonsState: movementButtonsState(),
      gameSettingsState: gameSettingsState(),
    }

  },
  methods: {
    endContact() {

      movementState().positionX = 0

      // musime dat manulane ukoncenie buttonu, aby sa ukoncil takisto actionPressed v inputs
      inputsManager.handleMouseUp()

    },
    changeMovement(positionX: number) {

      movementState().positionX = positionX

    }
  }
})
</script>

<style lang="less" scoped>
.positioner {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.placeholder {
  width: 300px;
}

.buttons-position {
  position: absolute;
  top: 0;
  left: 45%;
  transform: translate(-50%);
}
.bottom-right {
  transform-origin: bottom right;
  display: flex;
  justify-content: flex-end;
}
.bottom-left {
  transform-origin: bottom left;
  display: flex;
  justify-content: flex-start;
}
</style>
